/**
 * Projects service - Updated for v2 API with geocoding
 */
import apiClient from './api';

const projectsService = {
  /**
   * Get all projects for the tenant
   * @returns {Promise<Array>}
   */
  async getAll() {
    const response = await apiClient.get('/projects');
    return response.data;
  },

  /**
   * Get a single project by ID
   * @param {string} id
   * @returns {Promise<object>}
   */
  async getById(id) {
    const response = await apiClient.get(`/projects/${id}`);
    return response.data;
  },

  /**
   * Create a new project with geocoding
   * @param {object} data - Project data including address
   * @returns {Promise<object>}
   */
  async create(data) {
    const response = await apiClient.post('/projects', data);
    return response.data;
  },

  /**
   * Update a project
   * @param {string} id
   * @param {object} data
   * @returns {Promise<object>}
   */
  async update(id, data) {
    const response = await apiClient.put(`/projects/${id}`, data);
    return response.data;
  },

  /**
   * Delete a project
   * @param {string} id
   * @returns {Promise<object>}
   */
  async delete(id) {
    const response = await apiClient.delete(`/projects/${id}`);
    return response.data;
  },

  /**
   * Get all available work types
   * @returns {Promise<Array>}
   */
  async getWorkTypes() {
    const response = await apiClient.get('/projects/work-types/all');
    return response.data;
  },

  /**
   * Get project activities
   * @param {string} projectId
   * @returns {Promise<Array>}
   */
  async getActivities(projectId) {
    const response = await apiClient.get(`/projects/${projectId}/activities`);
    return response.data;
  },

  /**
   * Create a project activity
   * @param {string} projectId
   * @param {object} data
   * @returns {Promise<object>}
   */
  async createActivity(projectId, data) {
    const response = await apiClient.post(`/projects/${projectId}/activities`, data);
    return response.data;
  },
};

export default projectsService;
